module.exports = __webpack_public_path__ + "img/yishixiao@3x.850aabad.png";